const principles = [
  {
    icon: "ri-shield-check-line",
    title: "先分清事实与观点",
    desc: "能核实的时间、地点与公开表述归入事实，推测与评价单独标注，不让两者混在一起。",
  },
  {
    icon: "ri-bookmark-3-line",
    title: "每个关键点都可追溯",
    desc: "重要节点都会写明出处，方便你回到原始材料核对，而不是只接受转述。",
  },
  {
    icon: "ri-git-branch-line",
    title: "保留未被证实的部分",
    desc: "无法核实的内容不会被删掉，而是明确标记为「待确认」，避免读者被过度确定的说法误导。",
  },
  {
    icon: "ri-refresh-line",
    title: "随进展更新版本",
    desc: "事件有新回应时，我们更新原有时间线并保留修改说明，让你看到结论是怎样变化的。",
  },
];

export default function Principles() {
  return (
    <section className="w-full border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-8 md:py-16">
        <div className="max-w-2xl">
          <span className="text-xs font-semibold uppercase tracking-widest text-primary-600">
            内容原则
          </span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            我们如何对待每一条信息
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            复盘的价值在于可核对。以下四条，是我们整理每一起事件时都会遵守的底线。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {principles.map((item) => (
            <article key={item.title} className="rounded-lg border border-background-200 bg-background-50 p-5">
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}